import React from "react";
import {
  Card,
  Typography,
  Row,
  Col,
  Tag,
  Button,
  Space,
} from "antd";
import {
  EnvironmentOutlined,
  CompassOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const CurrentStopCard = ({
  point,
    distance,
    insideRadius,
    status,
    loading = false,
    onNavigate,
    onArrive,
    onComplete,
}) => {
  if (!point) return null;

  return (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
      }}
      bodyStyle={{
        padding: 18,
      }}
    >
      <Text
        type="secondary"
        style={{
          textTransform: "uppercase",
          letterSpacing: 1,
          fontSize: 11,
        }}
      >
        Current Delivery Stop
      </Text>

      <Title
        level={4}
        style={{
          marginTop: 8,
          marginBottom: 4,
        }}
      >
        {point.name}
      </Title>

      <Text type="secondary">{point.address || "-"}</Text>

      <div
        style={{
          marginTop: 16,
        }}
      >
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <Text strong>Distance</Text>

            <br />

            <Text>{distance != null ? `${Math.round(distance)} m` : "-"}</Text>
          </Col>

          <Col span={12}>
            <Text strong>Radius</Text>

            <br />

            <Text>{point.radius_meters || 100} m</Text>
          </Col>
        </Row>
      </div>

      <div
        style={{
          marginTop: 16,
        }}
      >
        <Tag color={insideRadius ? "success" : "default"}>
          {insideRadius ? "Inside Delivery Zone" : "Outside Delivery Zone"}
        </Tag>
      </div>

      <Space
        style={{
          marginTop: 20,
          width: "100%",
        }}
      >
        <Button icon={<CompassOutlined />} onClick={() => onNavigate?.(point)}>
          Navigate
        </Button>

        {status === "arrived" && (
          <Button type="primary" 
          icon={<CheckCircleOutlined/>} 
          onClick={onComplete}>            
            Complete Delivery
          </Button>
        )} 

        {status === "delivered" && (
          <Tag color="success">
            Delivered
          </Tag>
        )}
        
        {status !== "arrived" && status !== "delivered" && (
          <Button
          type="primary"
          icon={<CheckCircleOutlined/>}
            disabled={!insideRadius}
            loading={loading}
            onClick={() => onArrive(point)}
          >
            Arrived
          </Button>
        )}
      </Space>

      <div
        style={{
          marginTop: 18,
          padding: 12,
          background: "#fafafa",
          borderRadius: 6,
        }}
      >
        <Space>
          <EnvironmentOutlined />

          <Text type="secondary">Stop #{point.sequence_no}</Text>
        </Space>
      </div>
    </Card>
  );
};

export default CurrentStopCard;